import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireSite } from "/Users/manuelmoreale/Sites/03_Clients/teatrogrande.it/src/js/site.js";
var siteExports = requireSite();
export { siteExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(siteExports);